import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import React, { Component } from 'react';
import { string, func } from 'prop-types';
import Badge from '@instructure/ui-elements/lib/components/Badge';
import ScreenReaderContent from '@instructure/ui-a11y/lib/components/ScreenReaderContent';

var Indicator =
/*#__PURE__*/
function (_Component) {
  _inherits(Indicator, _Component);

  function Indicator() {
    _classCallCheck(this, Indicator);

    return _possibleConstructorReturn(this, _getPrototypeOf(Indicator).apply(this, arguments));
  }

  _createClass(Indicator, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        ref: this.props.indicatorRef
      }, React.createElement(Badge, {
        standalone: true,
        type: "notification",
        variant: this.props.variant
      }), React.createElement(ScreenReaderContent, null, this.props.title));
    }
  }]);

  Indicator.displayName = "Indicator";
  return Indicator;
}(Component);

Indicator.propTypes = {
  title: string.isRequired,
  variant: string.isRequired,
  indicatorRef: func
};
Indicator.defaultProps = {
  indicatorRef: function indicatorRef() {}
};
export { Indicator as default };